<template>
  <div
    class="
      absolute
      top-0
      left-0
      w-full
      h-full
      bg-black
      z-20
      flex flex-col
      items-center
      justify-center
      p-8
    "
  >
    <ViceLoader class="mb-32 h-14 w-14" v-if="isLoading" />
    <div
      v-else
      class="
        flex
        items-center
        text-white text-center
        font-bold
        py-2
        px-6
        mb-32
        border-2 border-white
        rounded-full
      "
    >
      <p class="text-white text-center">Waiting for your VCE clinician to join.</p>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue';
import ViceLoader from '@/Components/Loaders/ViceLoader.vue';

export default {
  name: 'ClinicianLeftOverlay',
  components: {
    ViceLoader,
  },
  setup() {
    const isLoading = ref(true);

    onMounted(() => {
      setTimeout(() => {
        isLoading.value = false;
      }, 5000);
    });
    return {
      isLoading,
    };
  },
};
</script>
